// import Columnists from "./Columnists";
// import Highlights from "./Categories/Highlights";
// import Latest from "./Categories/Latest";
// import MostViewed from "./Categories/MostViewed";
// import IndividualColumnist from "./IndividualColumnist";
// import NewsPost from "./NewsPost";
// import AllNews from "./AllNews";
// import StableTours from "./StableTours";

// lazyImport the above imports
import lazyImport from "../../../utils/lazyImport/lazyImport";
const Columnists = lazyImport(() => import("./Columnists"));
const Highlights = lazyImport(() => import("./Categories/Highlights"));
const Latest = lazyImport(() => import("./Categories/Latest"));
const MostViewed = lazyImport(() => import("./Categories/MostViewed"));
const IndividualColumnist = lazyImport(() => import("./IndividualColumnist"));
const NewsPost = lazyImport(() => import("./NewsPost"));
const AllNews = lazyImport(() => import("./AllNews"));
const StableTours = lazyImport(() => import("./StableTours"));

export default {
  AllNews,
  Columnists,
  MostViewed,
  Highlights,
  Latest,
  IndividualColumnist,
  NewsPost,
  StableTours,
};
